import { Component, input, computed } from '@angular/core';
import { RenderPayload } from '../../models/render-payload';
import { LayerRenderData } from '../../models/layer-render-data';
import { LayerComponent } from '../layer/layer.component';
import { LayoutStyleType } from '../../models/layout-style-type';

@Component({
    selector: 'app-display-renderer',
    standalone: true,
    imports: [LayerComponent],
    templateUrl: './display-renderer.component.html',
    styleUrl: './display-renderer.component.scss',
})
export class DisplayRendererComponent {
    readonly payload = input.required<RenderPayload>();
    readonly isFallback = input(false);

    readonly sortedLayers = computed<LayerRenderData[]>(() =>
        [...this.payload().layers].sort((a, b) => a.zIndex - b.zIndex)
    );

    readonly isRelativeLayout = computed(() => this.payload().layoutStyle === LayoutStyleType.Relative);
    readonly isStackLayout = computed(() => !this.isRelativeLayout());
}
